import { SUBMIT_SYNC_INPUT } from "constants/syncInput";

export default (state = 0, action) => {
  switch (action.type) {
    case SUBMIT_SYNC_INPUT:
      return state + 1;
    default:
      return state;
  }
};
